export default "__VITE_ASSET__CFJ2B0BE__"